import { render, staticRenderFns } from "./EditStockItem.vue?vue&type=template&id=184f8617&"
import script from "./EditStockItem.vue?vue&type=script&lang=ts&"
export * from "./EditStockItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports